export function servicesTable() {
    const showServiceTable = document.querySelectorAll('.js-showServiceTable');

    showServiceTable.forEach( item => {
        let table = item.parentNode.querySelector('.js-serviceTable');

        item.addEventListener('click', e => {
            table.classList.toggle('is-active');

            item.textContent = table.classList.contains('is-active') ? 'Скрыть таблицу' : 'Посмотреть таблицу';
        });
    });
}